import { GoToAccountSettingsCTA, GoToOrderFulfillmentCTA, SubmitVerificationInformationCTA } from "./ctas";
export var CONTACT_US_IF_FURTHER_HELP = function CONTACT_US_IF_FURTHER_HELP(strictLocalize) {
  return strictLocalize({
    id: "JxMIVR",
    defaultMessage: [{
      "type": 0,
      "value": "Neem contact met ons op als je meer hulp nodig hebt."
    }]
  });
};
export var getAccountSettingsCTA = function getAccountSettingsCTA(_context, strictLocalize) {
  return GoToAccountSettingsCTA(strictLocalize);
};
export var getOrderFulfillmentCTA = function getOrderFulfillmentCTA(context, strictLocalize) {
  var _context$brandOrder, _context$brandOrder$b;
  var brandOrderToken = (_context$brandOrder = context.brandOrder) === null || _context$brandOrder === void 0 ? void 0 : (_context$brandOrder$b = _context$brandOrder.brand_order) === null || _context$brandOrder$b === void 0 ? void 0 : _context$brandOrder$b.token;
  if (!brandOrderToken) {
    return undefined;
  }
  return GoToOrderFulfillmentCTA(brandOrderToken, strictLocalize);
};
export var getSubmitVerificationInformationCTA = function getSubmitVerificationInformationCTA(context, strictLocalize) {
  if (!context.brandIdvToken) {
    return undefined;
  }
  return SubmitVerificationInformationCTA(context.brandIdvToken, strictLocalize);
};